import React from "react";
import WebTheme from "../web-theme/WebTheme";
import AdminDashboardHome from "../pages/AdminDashboardHome";
import ManageUsers from "../pages/ManageUsers";
import ManagePlans from "../pages/ManagePlans";
import Orders from "../pages/Orders";
import PaymentGateway from "../pages/PaymentGateway";
import SiteSettings from "../pages/SiteSettings";
import StorageSettings from "../pages/StorageSettings";
import Translation from "../pages/Translation";
import EmailSettings from "../pages/EmailSettings";
import SupportTickets from "../pages/SupportTickets";
import EmailTemplates from "../pages/EmailTemplates";
import ProxySettings from "../pages/ProxySettings";

const Content = ({ selectedMenu }) => {
  const render = () => {
    switch (selectedMenu) {
      case "dashboard":
        return <AdminDashboardHome />;
      case "manage-users":
        return <ManageUsers />;
      case "manage-plans":
        return <ManagePlans />;
      case "orders":
        return <Orders />;
      case "payment-gateway":
        return <PaymentGateway />;
      case "site-settings":
        return <SiteSettings />;
      case "web-theme":
        return <WebTheme />;
      case "storage-settings":
        return <StorageSettings />;
      case "web-translation":
        return <Translation />;
      case "email-settings":
        return <EmailSettings />;
      case "support-tickets":
        return <SupportTickets />;
      case "email-templates":
        return <EmailTemplates />;
      case "proxy-settings":
        return <ProxySettings />;
      default:
        return <AdminDashboardHome />;
    }
  };
  return <div>{render()}</div>;
};

export default Content;
